// @flow
import React from "react";
import { Container } from "./styles";

const InfiniteLoading = ({ noMargin }) => (
  <Container noMargin>Loading...</Container>
);

export default InfiniteLoading;
